import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "../../axios";
import { Link, useNavigate } from "react-router-dom";

const GalleryList = () => {
  const [searchText, setSearchText] = useState("");
  const [galleryData, setGalleryData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    fetchGalleries();
  }, []);

  const fetchGalleries = async () => {
    try {
      const res = await axios.get("/galleries");
      setGalleryData(res.data);
    } catch (err) {
      console.error("Failed to fetch galleries", err);
      alert("Error loading galleries");
    }
  };

  const handleEdit = (id) => {
    // window.location.href = `/admin/addGallery/${id}`;
    navigate(`/admin/addGallery/${id}`);
  };

  const handleDelete = async (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete this image from the gallery?"
      )
    ) {
      try {
        await axios.delete(`/galleries/${id}`);
        fetchGalleries(); // Refresh after delete
      } catch (err) {
        console.error("Error deleting gallery:", err);
        alert("Failed to delete gallery image.");
      }
    }
  };

  const filteredData = galleryData.filter((gallery) =>
    String(gallery.event?.title || gallery.event_id || "")
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1,
      width: "100px",
      cell: (row, index) => <div className="text-center">{index + 1}</div>,
    },
    {
      name: "Event Name",
      selector: (row) => row.event?.title || "—",
      sortable: true,
      cell: (row) => (
        <div className="text-center">
          {row.event?.title ?? <span className="text-muted">No Event</span>}
        </div>
      ),
    },
    {
      name: "Image",
      cell: (row) => (
        <div className="text-center">
          <img
            src={row.image_url}
            alt="Gallery"
            style={{
              width: "80px",
              height: "60px",
              objectFit: "cover",
              borderRadius: "4px",
            }}
          />
        </div>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="action-buttons justify-content-center">
          <button
            className="edit-btn"
            onClick={() => handleEdit(row.id)}
            title="Edit">
            <i className="bi bi-pencil"></i>
          </button>
          <button
            className="delete-btn"
            onClick={() => handleDelete(row.id)}
            title="Delete">
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
      width: "150px",
    },
  ];

  return (
    <div className="main-content">
      <div className="page-header d-flex justify-content-between align-items-center">
        <h4>Gallery</h4>
        <Link to="/admin/addGallery" className="text-decoration-none">
          <button className="gold-add-btn text-white">+ Add Gallery</button>
        </Link>
      </div>

      <input
        type="text"
        className="search-input my-4"
        placeholder="Search galleries..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />

      <div className="data-table-container">
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          paginationPerPage={10}
          highlightOnHover
          responsive
          className="data-table"
          persistTableHead={true}
          noDataComponent={
            <div className="text-center py-4">No galleries found</div>
          }
        />
      </div>
    </div>
  );
};

export default GalleryList;
